import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Core.
import { ITaxonomyTerm, TAXONOMY_MEDICAL_SCHOOLS_ID, useAppDispatch } from 'core';

// Store.
import { getTaxonomyTermById } from 'store/taxonomy/actions';
import { medicalSchoolsSelector } from 'store/taxonomy/selectors';

export const useTaxonomyMedicalSchools = (): ITaxonomyTerm[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getTaxonomyTermById(TAXONOMY_MEDICAL_SCHOOLS_ID));
  }, [dispatch]);

  return useSelector(medicalSchoolsSelector);
};
